import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';

import {ClientInfoService} from '../../ClientInfo/client-info.service';
import {MatButtonToggleChange} from '@angular/material/button-toggle';

import {DrawViewService} from './draw-view.service';
import {ApplicationService} from '../../Application/application.service';
import {MatSlider} from '@angular/material/slider';


@Component({
    selector: 'burncase-draw-view',
    templateUrl: './draw-view.component.html',
    styleUrls: ['./draw-view.component.css']
})
export class DrawViewComponent implements AfterViewInit, OnInit {

    @ViewChild('slider', {static: true}) slider: ElementRef<MatSlider>;
    @ViewChild('headgroup') transformBtn;


    constructor(public applicationService: ApplicationService,
                public clientInfoService: ClientInfoService,
                public drawViewService: DrawViewService,
                private changeDetector: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.drawViewService.interactionMode = 'transform';
    }

    ngAfterViewInit(): void {
        // @ts-ignore needed to calculate slider speed
        // this._sliderWidth = this.slider._elementRef.nativeElement.getBoundingClientRect().width;
    }

    // -------------------------------------------------------------------------------------------------------------------------------------
    /**
     * triggers a function based on button type and number of clicks
     */
    public singleTap(event: Event, button: string) {
        this.selectMode(button, 1, event);
    }

    public doubleTap(event: Event, button: string) {
        this.selectMode(button, 2, event);
    }

    /**
     * uploads selected file if it is a valid image
     */
    public onPhotoSelected(event: any, uploader: any) {
        const files = event.target.files; // FileList object
        const file = files[0];
        this.drawViewService.uploadImage(file, uploader);
    }


    /**
     * untoggle all buttons in a toggle group
     */
    public toggleChanged(event: MatButtonToggleChange) {
        const toggle = event.source;
        if (toggle) {
            const group = toggle.buttonToggleGroup;

            // uncheck all buttons
            if (event.value.some(item => item === toggle.value)) {
                group.value = [toggle.value];
            }
        }
    }

    // -------------------------------------------------------------------------------------------------------------------------------------


    public selectMode(button: string, count: number, event: Event) {
        if (button !== 'measure') {
            this.drawViewService.deactivateMeasuring();
        }
        if (button === 'paint') {
            this.onPaintTap(event, count);
        } else if (button === 'erase') {
            this.onEraseTap(event, count);
        } else if (button === 'measure') {
            this.drawViewService.activateMeasureMode();
        } else if (button === 'info') {
            this.drawViewService.activateInfoMode();
        } else {
            this.drawViewService.activatePanMode();
        }

        this.changeDetector.detectChanges();
    }

    private onPaintTap(event: Event, count: number) {
        if (this.clientInfoService.isTouchDevice && count === 2) {
            this.drawViewService.openBrushSettingsDialog();
        } else {
            this.drawViewService.changePaintMode();
        }
    }

    private onEraseTap(event: Event, count: number) {
        if (this.clientInfoService.isTouchDevice && count === 2) {
            this.drawViewService.openBrushSettingsDialog();
        } else {
            this.drawViewService.changeEraseMode();
        }
    }

    public save() {
        console.log('save');
    }
}
